/* Smart Bar - custom style - Cedrus */
document.addEventListener('DOMContentLoaded', function() {
  var counter = 1;
  
  var interval = setInterval(function() {
    counter += 1;
    
    var bars = document.querySelector('.smartbar-barlist');
    
    if (bars) {
      var currency = document.querySelector('[g-bold-mc-picker-mnt]');
      
      if (currency) {
        currency.style.top = '50px';
      }

      clearInterval(interval);
    }
    
    if (counter > 20) {
      clearInterval(interval);
    }
  }, 300);
});